var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.7476L7.88752 19.3866C7.27187 19.632 6.57388 19.3318 6.32851 18.7161C6.26243 18.5503 6.23417 18.3719 6.24578 18.1938L6.53378 13.7761L3.70412 10.3714C3.28052 9.86169 3.35031 9.10511 3.86 8.6815C3.99726 8.56742 4.15824 8.4854 4.33121 8.44141L8.62169 7.35016L10.9854 3.60689C11.3392 3.04651 12.0803 2.87909 12.6407 3.23293C12.7916 3.32822 12.9194 3.45598 13.0147 3.60689L15.3783 7.35016L19.6688 8.44141C20.3111 8.60477 20.6993 9.25788 20.536 9.90017C20.492 10.0731 20.41 10.2341 20.2959 10.3714L17.4662 13.7761L17.7542 18.1938C17.7973 18.8551 17.2962 19.4262 16.6348 19.4693C16.4567 19.4809 16.2783 19.4527 16.1125 19.3866L12 17.7476Z",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a887fb6f.svg";
export { ForwardRef as ReactComponent };